import * as React from "react";

function SvgIconPixelSize(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.917 24.083H0V34h26.917v-9.917zM25.5 25.5H1.417v7.083H25.5V25.5z"
        fill="#414042"
      />
      <path
        d="M2.833 26.917H4.25v4.25H2.833v-4.25zM4.25 28.333H17v1.417H4.25v-1.417zM17 26.917h1.417v4.25H17v-4.25zM19.833 29.75h1.417v1.417h-1.417V29.75zM22.667 26.917h1.416v1.416h-1.416v-1.416zM22.667 29.75h1.416v1.417h-1.416V29.75zM21.25 28.333h1.417v1.417H21.25v-1.417zM19.833 26.917h1.417v1.416h-1.417v-1.416zM28.333 28.333H34V34h-5.667v-5.667zM0 11.333h5.667V17H0v-5.667zM11.333 11.333H17V17h-5.667v-5.667zM22.667 11.333h5.666V17h-5.666v-5.667zM5.667 17h5.666v5.667H5.667V17zM17 17h5.667v5.667H17V17zM28.333 17H34v5.667h-5.667V17zM0 0h5.667v5.667H0V0zM11.333 0H17v5.667h-5.667V0zM22.667 0h5.666v5.667h-5.666V0zM5.667 5.667h5.666v5.666H5.667V5.667zM17 5.667h5.667v5.666H17V5.667zM28.333 5.667H34v5.666h-5.667V5.667z"
        fill="#414042"
      />
    </svg>
  );
}

export default SvgIconPixelSize;
